<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#statistics"
                            @click="gotoTab(1)">
                            {{ $t('transaction_routing.statistics') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#setting" @click="gotoTab(2)">
                            {{ $t('transaction_routing.setting') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#psp_list" @click="gotoTab(3)">
                            {{ $t('transaction_routing.psp_list') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 4 ? 'active' : '']" href="#psp_errors"
                            @click="gotoTab(4)">
                            {{ $t('transaction_routing.psp_errors') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="statistics">
                    <statistics></statistics>
                </div>
                <div :class="['tab-pane', currentTab === 2 ? 'active' : '']" id="setting">
                    <routing-setting></routing-setting>
                </div>
                <div :class="['tab-pane', currentTab === 3 ? 'active' : '']" id="psp_list">
                    <psp-list></psp-list>
                </div>
                <div :class="['tab-pane', currentTab === 4 ? 'active' : '']" id="psp_errors">
                    <psp-errors></psp-errors>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import routing_setting from "./core-routing-setting";
import psp_list from "./psp-list";
import statistics from "./statistics";
import pspErrors from './psp-errors'

export default {
    components: {
        'routing-setting': routing_setting,
        'psp-list': psp_list,
        'statistics': statistics,
        'psp-errors': pspErrors,
    },
    data() {
        return {
            currentTab: 1,
        }
    },
    methods: {
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
            window.localStorage.setItem('tr_routing_active_tab', selectedTab);
        },
    },
    mounted() {
        if (window.localStorage.getItem('secondPreviousRoutePath') === this.$router.history.current.path) {
            let tab = window.localStorage.getItem('tr_routing_active_tab');
            this.currentTab = (tab != null && tab != undefined) ? parseInt(tab) : 1;
        }
    }


}
</script>

<style scoped></style>